export class CustomerServiceResponse {
    public RequestId: string;
    public RequestNotes: string;
    public RequestSequence: string;
    public IsAddressUpdateRequestOutsideOrangeCounty: boolean;
}
